'use client';
import React, { useEffect } from 'react';
function ViralLoopsFormWidget({ ucid, popup }) {
  function loadViralLoops() {
    const SCRIPT_SRC = 'https://app.viral-loops.com/widgetsV2/core/loader.js';
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
        resolve(1);
      } else {
        const script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.onload = () => resolve(1);
        script.onerror = reject;
        document.head.appendChild(script);
      }
    });
  }

  useEffect(() => {
    loadViralLoops();
  }, []);

  if (!ucid) return null;

  return (
    <form-widget
      ucid={ucid}
      mode={popup ? 'popup' : 'form'}
      component="customButton"
      redirect-url="https://viral-loops.com"
    ></form-widget>
  );
}

export default ViralLoopsFormWidget;
